import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Phone } from "lucide-react";
import { api, formatApiError, fmtDate } from "@/lib/api";
import { PageHead } from "@/components/admin/PageHead";
import StatusBadge from "@/components/common/StatusBadge";

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/enquiries").then(({ data }) => setItems(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (e) => {
    try {
      await api.patch(`/admin/enquiries/${e.id}`, { status: e.status === "new" ? "handled" : "new" });
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div data-testid="admin-enquiries-page">
      <PageHead title="Enquiries" subtitle="Messages sent from the website contact forms." />
      <div className="space-y-4">
        {items.map((e) => (
          <div key={e.id} className={`panel p-6 ${e.status === "new" ? "border-blue-500/30" : ""}`} data-testid={`admin-enquiry-${e.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-3"><p className="font-display text-lg text-white">{e.subject}</p><StatusBadge status={e.status} /></div>
                <p className="mt-1 text-sm text-slate-400">{e.name} · {fmtDate(e.created_at)}</p>
              </div>
              <button onClick={() => toggle(e)} className="btn-ghost !px-4 !py-1.5 text-xs" data-testid={`admin-enquiry-toggle-${e.id}`}>
                Mark as {e.status === "new" ? "handled" : "new"}
              </button>
            </div>
            <p className="mt-4 whitespace-pre-line text-sm leading-relaxed text-slate-300">{e.message}</p>
            <div className="mt-4 flex flex-wrap gap-6 text-sm">
              <a href={`mailto:${e.email}`} className="inline-flex items-center gap-2 text-emerald-400 hover:underline"><Mail className="h-4 w-4" />{e.email}</a>
              {e.phone && <span className="inline-flex items-center gap-2 text-slate-400"><Phone className="h-4 w-4" />{e.phone}</span>}
            </div>
          </div>
        ))}
        {!items.length && <p className="text-slate-500" data-testid="admin-enquiries-empty">No enquiries yet.</p>}
      </div>
    </div>
  );
}
